angular.module('eatself')
.filter('tr', function() {
  return function(str) {
	return str;
  };
})